import { z } from 'zod';

import { useForm } from '@pletly/ui';

const formSchema = z.object({
	date: z.date(),
	time: z.date(),
});

type Options = {
	defaultValues?: z.infer<typeof formSchema>;
};

export const useScheduleForm = (options?: Options) => {
	return useForm(formSchema, options);
};

export type ScheduleFormMethods = ReturnType<typeof useScheduleForm>;
